module.exports = __webpack_public_path__ + "static/img/background.8afcff8f.svg";